import { createFileRoute } from "@tanstack/react-router";

import { ComponentGallery } from "@/components/dev/component-gallery";

export const Route = createFileRoute("/dev/components/")({
  head: () => ({
    meta: [
      { title: "Component Lab - Scoopulator" },
      {
        name: "description",
        content: "Interactive development gallery for Scoopulator components.",
      },
      { name: "robots", content: "noindex, nofollow" },
    ],
  }),
  component: ComponentGallery,
});
